var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "site-footer" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "apps-footer" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "track",
                rawName: "v-track:click",
                value: { axId: "clicked_ios_app_link_from_homepage" },
                expression: "{ axId: 'clicked_ios_app_link_from_homepage' }",
                arg: "click"
              }
            ],
            staticClass: "b-sprite-global-apple-app-store ax-click",
            attrs: {
              href:
                "https://itunes.apple.com/app/apple-store/id913335252?pt=105095803&ct=brilliant_website_footer&mt=8",
              rel: "nofollow"
            }
          },
          [
            _vm._v(
              "\n        Practice math and science questions on the Brilliant iOS app.\n      "
            )
          ]
        ),
        _vm._v(" "),
        !_vm.hideGooglePlayButton
          ? _c(
              "a",
              {
                directives: [
                  {
                    name: "track",
                    rawName: "v-track:click",
                    value: { axId: "clicked_android_app_link_from_homepage" },
                    expression:
                      "{ axId: 'clicked_android_app_link_from_homepage' }",
                    arg: "click"
                  }
                ],
                staticClass: "b-sprite-global-google-play css-sprite-global",
                attrs: {
                  href:
                    "https://play.google.com/store/apps/details?id=org.brilliant.android&referrer=utm_source%3Dbrilliant%26utm_medium%3Dsite%26utm_campaign%3Dplaystore_full_footer_icon",
                  rel: "nofollow"
                }
              },
              [
                _vm._v(
                  "\n        Practice math and science questions on the Brilliant Android app.\n      "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "site-footer-main unstyled" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { name: "about" } } }, [
              _vm._v("About")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { name: "careers_page" } } }, [
              _vm._v("Careers")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { name: "testimonials" } } }, [
              _vm._v("Testimonials")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { name: "flatpage_faq" } } }, [
              _vm._v("Help")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                attrs: { to: { name: "flatpage_termsofuse" }, rel: "nofollow" }
              },
              [_vm._v("Terms")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "flatpage_privacypolicy" },
                  rel: "nofollow"
                }
              },
              [_vm._v("Privacy")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                attrs: { to: { name: "flatpage_ccpa_policy" }, rel: "nofollow" }
              },
              [_vm._v("California Privacy Policy")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("li", [_vm._v("© Brilliant " + _vm._s(new Date().getFullYear()))])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "social" }, [
      _c(
        "a",
        {
          staticClass: "b-sprite-global-twitter inline",
          attrs: { href: "https://twitter.com/brilliantorg", rel: "nofollow" }
        },
        [_vm._v("Twitter")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "social" }, [
      _c(
        "a",
        {
          staticClass: "b-sprite-global-facebook inline",
          attrs: {
            href: "https://www.facebook.com/brilliantorg",
            rel: "nofollow"
          }
        },
        [_vm._v("Facebook")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }